import { InputBase } from "@mui/material";
import { styled } from "@mui/material/styles";

export const StyledInputBase = styled(InputBase)({
  flex: 1,
  fontSize: "0.96rem",

  "& input[type=number]": {
    MozAppearance: "textfield",
  },

  "& input[type=number]::-webkit-outer-spin-button": {
    WebkitAppearance: "none",
    margin: 0,
  },

  "& input[type=number]::-webkit-inner-spin-button": {
    WebkitAppearance: "none",
    margin: 0,
  },
});
